import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useSiteSettings } from "@/hooks/useSiteSettings";
import { BRAND } from "@/constants/brand";

export function Footer() {
  const { t } = useTranslation();
  const { getSetting, isLoading } = useSiteSettings();

  const disclaimerFull = getSetting(
    "footer_disclaimer",
    BRAND.legal.disclaimer
  );

  const disclaimerShort = getSetting(
    "footer_disclaimer_short",
    "Informações educacionais. Consulte um profissional de saúde."
  );

  if (isLoading) return null;

  return (
    <footer className="mt-auto border-t bg-muted/30">
      <div className="container mx-auto px-4 py-6">
        <div className="flex flex-col items-center gap-3 text-center">
          {/* Mobile: versão curta */}
          <p className="text-sm text-muted-foreground md:hidden max-w-sm">
            {disclaimerShort}
          </p>
          
          {/* Desktop: versão completa */}
          <p className="hidden text-sm leading-relaxed text-muted-foreground md:block max-w-3xl">
            {disclaimerFull}
          </p>

          {/* Links legais */}
          <div className="flex items-center gap-4 text-xs text-muted-foreground/70">
            <Link to="/privacidade" className="underline hover:text-foreground transition-colors">
              {t("footer.privacyPolicy")}
            </Link>
            <span aria-hidden="true">•</span>
            <Link to="/termos" className="underline hover:text-foreground transition-colors">
              {t("footer.termsOfUse")}
            </Link>
          </div>
          
          <div className="text-xs text-muted-foreground/70">
            © {BRAND.legal.year} {BRAND.name}
          </div>
        </div>
      </div>
    </footer>
  );
}
